import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loading from "../Modals/Loading";
import userService from "../Services/userService";
import SetPasswordModal from "../Components/SetPasswordModal";
import { FiEdit3 } from "react-icons/fi";
import { HiOutlineTrash } from "react-icons/hi";
import { LuEye } from "react-icons/lu";
import Head from "../Components/Head";

const Users = () => {
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const getUsers = async () => {
      try {
        setLoading(true);
        const response = await userService.fetchAll();
        setUsers(response.users);
        console.log(response.users);
        setLoading(false);
      } catch (error) {
        console.log(error);
      }
    };
    getUsers();
  }, []);

  const navigate = useNavigate();
  return (
    <main className="mx-10 mt-2 p-6 rounded-3xl border border-gray-200 shadow-lg bg-white min-h-[calc(100vh-48px)]">
      <SetPasswordModal open={open} setOpen={setOpen} />
      {loading ? (
        <Loading />
      ) : (
        <>
          <Head
            heading={"Users"}
            button_text={"Add User"}
            navigation={() => navigate("/users/add")}
          />

          {/* Table */}
          <div className="table-div">
            <table>
              <thead>
                <tr className="border-y-2 text-center w-full text-black text-[10px]">
                  <th className="py-4 w-[3%] rounded-tl-lg pl-4 text-left">
                    Name
                  </th>
                  <th className="py-4 w-[3%] text-left">Email</th>
                  <th className="py-4 w-[3%]">Status</th>
                  <th className="py-4 w-[2%]">Set Password</th>
                  <th className="py-4 w-[2%]">Details</th>
                  <th className="py-4 w-[2%]">Edit</th>
                  <th className="py-4 w-[2%]">Delete</th>
                </tr>
              </thead>
              <tbody>
                {users?.map((value, index) => (
                  <tr
                    key={index}
                    className="bg-accent border-b border-gray-100 text-left"
                  >
                    <td className="py-4 w-[3%] pl-4 font-semibold">
                      {value.name}
                    </td>
                    <td className="py-4 w-[3%] font-bold text-gray-400">
                      {value.email}
                    </td>
                    <td className="py-4 w-[3%]">
                      <div className="flex justify-center">
                        <p
                          className={`flex px-4 py-1 rounded-md font-bold uppercase bg-opacity-20 ${value.status === "active" ? "bg-green-600 text-green-500" : "bg-red-500 text-red-500"}`}
                        >
                          {value.status}
                        </p>
                      </div>
                    </td>
                    <td className="w-[4%]">
                      <div className="flex justify-center">
                        <button
                          onClick={() => setOpen(true)}
                          className="button-primary !w-[120px] !text-[10px] !font-semibold !bg-cyan-500 !text-white !py-1"
                        >
                          Set Password
                        </button>
                      </div>
                    </td>
                    <td className="w-[2%]">
                      <div className="flex justify-center">
                        <button>
                          <LuEye className="h-4 w-4 text-sky-500" />
                        </button>
                      </div>
                    </td>
                    <td className="w-[2%]">
                      <div className="flex justify-center">
                        <button
                          onClick={() => navigate("/users/edit?id=" + value.id)}
                        >
                          <FiEdit3 className="h-4 w-4 text-indigo-500" />
                        </button>
                      </div>
                    </td>
                    <td className="w-[2%]">
                      <div className="flex justify-center">
                        <button>
                          <HiOutlineTrash className="h-4 w-4 text-red-500" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </main>
  );
};

export default Users;
